module.exports = __webpack_public_path__ + "906e4d44b76d74d387e0654a270ca83f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Swift-Icons.svg?-v0i0qt
// module id = 1488
// module chunks = 0